<template>
  <img
    v-if="src"
    :src="src"
    :alt="alt"
    :width="width"
    :height="height"
    :loading="priority ? 'eager' : 'lazy'"
    :fetchpriority="priority ? 'high' : 'low'"
    decoding="async"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'ProductImage',
  props: {
    src: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    width: {
      type: [Number, String],
      default: 250,
    },
    height: {
      type: [Number, String],
      default: 250,
    },
    priority: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
